import { useLayoutEffect } from 'react';
import { useAuthForm } from '../providers/auth/auth';

type Props = {};

const AccountLogout = (props: Props) => {
  const { logout } = useAuthForm();

  useLayoutEffect(() => {
    logout();
  }, [logout]);

  return null;
};

export default AccountLogout;
